{
    "Accessibility menu": "Barrierefreiheits-Menü",
    "Close": "Schließen",
    "Content adjustments": "Inhaltsanpassungen",
    "Navigation adjustments": "Navigationsanpassungen",
    "Text Align": "Textausrichtung",
    "Align Left": "Links ausrichten",
    "Align Center": "Zentrieren",
    "Align Right": "Rechts ausrichten",
    "Adjust Font Size": "Schriftgröße anpassen",
    "Highlight Title": "Titel hervorheben",
    "Highlight Links": "Links hervorheben",
    "Readable Font": "Lesbare Schriftart",
    "Colour adjustments": "Farbanpassungen",
    "Dark Contrast": "Dunkler Kontrast",
    "Light Contrast": "Heller Kontrast",
    "High Contrast": "Hoher Kontrast",
    "High Saturation": "Hohe Sättigung",
    "Low Saturation": "Niedrige Sättigung",
    "Monochrome": "Monochrom",
    "Tools": "Werkzeuge",
    "Reading Guide": "Leseführung",
    "Big Cursor": "Großer Cursor",
    "Increase Font Size": "Schriftgröße vergrößern",
    "Decrease Font Size": "Schriftgröße verkleinern",
    "Letter Spacing": "Buchstabenabstand",
    "Line Height": "Zeilenhöhe",
    "Font Weight": "Schriftstärke",
    "Dyslexia Font": "Legasthenie-Schriftart",
    "Language": "Sprache",
    "Accessibility widget": "Barrierefreiheits-Menü öffnen",
    "Accessibility Profiles": "Barrierefreiheits-Profile",
    "Cognitive Disability": "Kognitive Beeinträchtigung",
    "Seizure Safe": "Anfallssicher",
    "Accessibility statement": "Barrierefreiheits-Erklärung",
    "ADHD": "ADHS",
    "Low Vision": "Sehschwäche",
    "Pause Animations": "Animationen pausieren",
    "Animation paused": "Animation pausiert",
    "Reset all settings": "Einstellungen zurücksetzen",
    "Shortcut:": "Tastenkürzel:",
    "Epilepsy Safe Mode": "Epilepsie-sicherer Modus",
    "Mute sounds": "Töne stummschalten",
    "Page read": "Seite vorlesen",
    "Page read controls": "Vorlese-Steuerung",
    "Pause": "Pause",
    "Resume": "Fortsetzen",
    "Stop": "Stopp",
    "Settings": "Einstellungen",
    "Speed": "Geschwindigkeit",
    "Voice": "Stimme",
    "Close accessibility menu": "Barrierefreiheitsmenü schließen",
    "Back to accessibility menu": "Zurück zum Barrierefreiheitsmenü",
    "Search languages": "Sprachen suchen",
    "Selected language": "Ausgewählte Sprache",
    "View accessibility statement (opens in new window)": "Barrierefreiheitserklärung ansehen (öffnet in neuem Fenster)",
    "Visit CookieYes website (opens in new window)": "CookieYes-Website besuchen (öffnet in neuem Fenster)",
    "Reset all accessibility settings to default": "Alle Barrierefreiheitseinstellungen zurücksetzen"
}
